import { Route } from '@angular/router';
import { authStepGuard } from './config/auth-flow.guards';
import { onboardingReloadGuard } from './config/onboarding.guard';
import { redirectInvalidPvzLinkGuard } from './config/pvz-invalid-link.guard';
import { AuthFlowId, AuthStepRoute } from './models/auth-flow.models';
import { AuthShellPage } from './pages/auth-shell.page';
import { ConfirmEmailStepComponent } from './steps/confirm-email-step/confirm-email-step.component';
import { EnterEmailStepComponent } from './steps/enter-email-step/enter-email-step.component';
import { OnboardingStepComponent } from './steps/onboarding-step/onboarding-step.component';
import { PvzLinkStepComponent } from './steps/pvz-link-step/pvz-link-step.component';
import { PvzPincodeStepComponent } from './steps/pvz-pincode-step/pvz-pincode-step.component';
import { PvzSubstituteStepComponent } from './steps/pvz-substitute-step/pvz-substitute-step.component';
import { SelectAccountStepComponent } from './steps/select-account-step/select-account-step.component';
import { TelVerificationStepComponent } from './steps/tel-verification-step/tel-verification-step.component';

export const LOGIN_V2_CHILDREN: Route[] = [
  {
    path: '',
    component: EnterEmailStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Code,
    component: ConfirmEmailStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Accounts,
    component: SelectAccountStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Tel,
    component: TelVerificationStepComponent,
    canActivate: [authStepGuard, onboardingReloadGuard],
  },
];

export const REGISTRATION_CHILDREN: Route[] = [
  {
    path: '',
    component: EnterEmailStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Code,
    component: ConfirmEmailStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Tel,
    component: TelVerificationStepComponent,
    canActivate: [authStepGuard, onboardingReloadGuard],
  },
  {
    path: AuthStepRoute.Onboarding,
    component: OnboardingStepComponent,
    canActivate: [authStepGuard, onboardingReloadGuard],
  },
];

export const PVZ_CHILDREN: Route[] = [
  {
    path: '',
    component: PvzLinkStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Pincode,
    component: PvzPincodeStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: AuthStepRoute.Substitute,
    component: PvzSubstituteStepComponent,
    canActivate: [authStepGuard],
  },
  {
    path: '**',
    canActivate: [redirectInvalidPvzLinkGuard],
    component: PvzLinkStepComponent,
  },
];

export function createAuthShellRoute(path: string, flowId: AuthFlowId, children: Route[]): Route {
  return {
    path,
    component: AuthShellPage,
    data: { flowId },
    children,
  };
}